export default __webpack_public_path__ + "static/media/avax.a3f3731d.svg";